
/* TK Shopify Cookie Banner - Mobile Compact V1.0 */
(function () {
  'use strict';

  const MOBILE_WIDTH = 749;
  const BANNER_ID = 'shopify-pc__banner';

  function setStyles(el, styles) {
    if (!el) return;

    Object.entries(styles).forEach(([key, value]) => {
      el.style.setProperty(key, value, 'important');
    });
  }

  function applyCompactBanner() {
    // 只修改移动端
    if (window.innerWidth > MOBILE_WIDTH) return;

    const banner = document.getElementById(BANNER_ID);
    if (!banner) return;

    // 避免重复应用
    if (banner.dataset.tkCompact === '1') return;

    const wrapper = banner.querySelector(
      '.shopify-pc__banner__wrapper'
    );

    const body = banner.querySelector(
      '.shopify-pc__banner__body'
    );

    const title = banner.querySelector('h2');
    const paragraph = banner.querySelector('p');

    const buttons = banner.querySelector(
      '.shopify-pc__banner__btns'
    );

    const accept = banner.querySelector(
      '#shopify-pc__banner__btn-accept'
    );

    const decline = banner.querySelector(
      '#shopify-pc__banner__btn-decline'
    );

    const prefs = banner.querySelector(
      '#shopify-pc__banner__btn-manage-prefs'
    );

    // 横幅整体
    setStyles(banner, {
      'box-sizing': 'border-box',
      'padding': '14px 16px',
      'max-height': '85dvh',
      'overflow-y': 'auto'
    });

    setStyles(wrapper, {
      'padding': '0',
      'margin': '0',
      'gap': '0'
    });

    // 文字区域
    setStyles(body, {
      'padding': '0',
      'margin': '0 0 12px'
    });

    setStyles(title, {
      'font-size': '18px',
      'line-height': '1.3',
      'margin': '0 0 8px'
    });

    setStyles(paragraph, {
      'font-size': '13px',
      'line-height': '1.4',
      'margin': '0'
    });

    // 按钮区域
    setStyles(buttons, {
      'display': 'grid',
      'grid-template-columns': 'repeat(2, minmax(0, 1fr))',
      'gap': '8px',
      'padding': '0',
      'margin': '0'
    });

    [accept, decline, prefs].forEach(btn => {
      setStyles(btn, {
        'box-sizing': 'border-box',
        'width': '100%',
        'min-width': '0',
        'min-height': '44px',
        'height': 'auto',
        'padding': '8px 6px',
        'margin': '0',
        'font-size': '13px',
        'line-height': '1.3'
      });
    });

    // 拒绝按钮：左侧
    setStyles(decline, {
      'grid-column': '1',
      'grid-row': '1'
    });

    // 接受按钮：右侧
    setStyles(accept, {
      'grid-column': '2',
      'grid-row': '1'
    });

    // 偏好管理：第二行
    setStyles(prefs, {
      'grid-column': '1 / -1',
      'grid-row': '2'
    });

    banner.dataset.tkCompact = '1';
  }

  function init() {
    applyCompactBanner();

    // 处理 Shopify Cookie Banner 延迟加载
    const observer = new MutationObserver(() => {
      if (
        window.innerWidth <= MOBILE_WIDTH &&
        document.getElementById(BANNER_ID)
      ) {
        applyCompactBanner();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // 横竖屏切换后重新应用
    window.addEventListener('resize', () => {
      const banner = document.getElementById(BANNER_ID);

      if (banner && window.innerWidth <= MOBILE_WIDTH) {
        banner.dataset.tkCompact = '';
        applyCompactBanner();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
